import { cn } from '../../lib/cn.js'

/**
 * A torn-off calendar leaf: the month on a coloured band, the number large
 * beneath it, the weekday quiet under that.
 *
 * `.fawn-hero__date` in the kit, and the right way to say *when* something
 * happens. An appointment's subject is its hour — the booking record led with
 * two portraits and read as a profile of two people who happen to have met.
 *
 * Read as one object, so the three parts are one element and not three.
 */
export function DateLeaf({ iso, className }: { iso: string | undefined; className?: string }) {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return (
    <div
      className={cn(
        'bg-surface w-14 shrink-0 overflow-hidden rounded-md text-center',
        'shadow-e3',
        className,
      )}
    >
      <span className="bg-coral-fill text-on-coral text-eyebrow block py-1 font-semibold uppercase tracking-[.12em]">
        {d.toLocaleDateString('en-CA', { month: 'short' })}
      </span>
      <span className="text-navy text-section block pt-0.5 font-medium tabular-nums leading-none">
        {d.getDate()}
      </span>
      {/* Full strength, no opacity: quieting this with `opacity` greys the
          whole leaf rather than only the word, which the kit says in as many. */}
      <span className="text-ink-muted text-micro block pb-1">
        {d.toLocaleDateString('en-CA', { weekday: 'short' })}
      </span>
    </div>
  )
}
